import { JOB_STATUS }             from '../02_api'
import { FACTORY }                from '../09_model_app'


export async function get_job_status_id ( status: JOB_STATUS )
{
  const enum_job_status = await FACTORY.JOB_STATUS.data_for( {}, 0 ).on_ready( )
      , job_status = (enum_job_status.data || []).filter( job => job.name === status )[ 0 ] ;

  return enum_job_status.error || !job_status? false : job_status.id ;
}